<template>
	<div class="div1">
		<el-backtop target=".div1"></el-backtop>
		<!-- 头部 -->
		<!-- <Head :data="searchList"></Head> -->
		<Head :data="searchList?searchList:[]"></Head>
		<!-- 中部内容 -->
		<div style="background: #f6f5f7">
			<!-- 导航 -->
			<div class="navigation">
				<div class="navList">
					<div v-for="(item, index) in navList.slice(0,6)" :key="index"
						:style="{borderColor:index == active?'#E1251B':''}" :class="index == 0 ? 'active' : ''"
						class="navName" @click="onNavigation(index,item)">
						{{ item.title }}
						<!-- <div class="line" v-if="index == active"></div> -->
					</div>
				</div>
			</div>
			<!-- 第一部分 -->
			<div class="banner" style="background: #fc8181;margin-top: 4px;">
				<div class="ones tong" v-if="active == 1">
					<!-- 左边 -->
					<div class="ist is_left">
						<!--<div class="left_title">家用电器</div>-->
						<div class="left_list">
							<div class="listName" v-for="(item, index) in leftList.cate_list" :key="index">
								<span v-for="(item1, index1) in item.cate_two" :key="index1">
									<span class="nameCl" @click="onClick(item1.id)">{{item1.name}}</span>
									<span v-if="index1 + 1 < item.cate_two.length">/</span>
								</span>
							</div>
						</div>
					</div>
					<!-- 中间 -->
					<div class="ist is_conts">
						<el-carousel height="325px">
							<el-carousel-item v-for="(item, index) in leftList.banner" :key="index">
								<img :src="item.banner" class="bannerName" @click="bannerSkip(item)" />
							</el-carousel-item>
						</el-carousel>
						<div style="height:100px;margin-top: 15px;">
							<div class="conts_top" v-for="(item, index) in secondsList" :key="index" v-if="index>4 && index<9"
								@click="switchovers(item)">
								<div class="conts_two">
									<div class="two_text">{{item.title}}</div>
									<div class="two_span">图书/文娱/</div>
								</div>
								<div class="conts_three">
									<img class="three_img" :src="item.image" />
								</div>
							</div>

						</div>
					</div>

					<!-- 右边 -->
					<div class="ist is_right">
						<div class="rightTop">
							<img :src="image_url ? image_url : '../../../static/logo.png'" class="imgTop" />
							<div class="topR" v-if="token">
								<div class="Rname">{{ userName }}</div>
								<!-- <div class = "Ryaoqingma">邀请码：{{ relationId }}</div> -->
							</div>
							<div class="topL" v-if="!token">
								<div class="Rname" @click="goLogin()">登录/注册</div>
							</div>
						</div>

						<div class="Rclass" @click="goOrder()">
							<div class="classList">
								<div class="RlistNum">{{ leftList.user_order_num?leftList.user_order_num.daifu_num:0 }}
								</div>
								<div class="RlistName">待付款</div>
							</div>
							<div class="classList">
								<div class="RlistNum">{{ leftList.user_order_num?leftList.user_order_num.daifa_num:0 }}
								</div>
								<div class="RlistName">待发货</div>
							</div>
							<div class="classList">
								<div class="RlistNum">
									{{ leftList.user_order_num?leftList.user_order_num.daishou_num:0 }}
								</div>
								<div class="RlistName">待收货</div>
							</div>
							<div class="classList">
								<div class="RlistNum">
									{{ leftList.user_order_num?leftList.user_order_num.daiping_num:0 }}
								</div>
								<div class="RlistName">待评价</div>
							</div>
						</div>
						<div class="Rbottom">
							<div class="bottomS">
								<div>{{ leftList.gonggao?leftList.gonggao.title:'' }}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- 第二部分 -->
			<div class="tong buffer" v-if="active == 1">
				<div>为你推荐</div>
				<div style="color: #999;cursor: pointer;" @click="gotoMoreGoods">查看更多 ></div>
			</div>
			<div class="tong second" v-if="active == 1">
				<div class="seconds">
					<div class="secondsleft">
						<div class="backg1">
							<div class="secondsleft_title">精选专题</div>
							<div class="secondsleft_dixy">懂你想要</div>
						</div>
						<div class="backg2"></div>
					</div>
					<div class="secondsRight">
						<div class="secondsRight_list" v-for="(item, index) in leftList.tuijian_goods_list" :key="index"
							@click="switchover(item)">
							<img class="secondsRight_img" :src="item.goods_image" />
							<div class="secondsRight_title">{{ item.title }}</div>
							<div style="display: flex;justify-content: space-between;align-items: center;">
								<div v-if="token" style="color: #ff2d55; font-size: 22px">
									¥{{ item.vip_price }}
								</div>
								<div v-else style="color: #ff2d55; font-size: 22px">
									¥{{ item.new_price }}
								</div>
								<div style="color: #666666; font-size: 12px">
									月销{{ item.goods_sales }}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- 第三部分 -->
			<div class="tong buffer1" v-if="active == 1">为你推荐</div>
			<div class="tong three" v-if="active == 1">
				<div class="navList2">
					<div v-for="(item, index) in navList1" :key="index" class="navName1"
						@click="onNavigation1(index, item)">
						<div :class="index == active1 ? 'active1' : ''">
							{{ item.name }}
						</div>
					</div>
				</div>
			</div>
			<div class="tong three"
				v-if="active == 1 && navList1[active1] && navList1[active1].theme_goods_list.data.length != 0">
				<goodsItem :title="title" :isVip="relationId ? true : false"
					:data="navList1[active1]?navList1[active1].theme_goods_list.data:[]"></goodsItem>
			</div>
			<div class="tong three"
				v-if="active == 1 && navList1[active1] && navList1[active1].theme_goods_list.data.length != 0">
				<el-pagination background style="text-align: center; padding-bottom: 50px" layout="prev, pager, next"
					:total="navList1[active1]?navList1[active1].theme_goods_list.total:0"
					@current-change="handleCurrentChange" :current-page="page" :page-size="20">
				</el-pagination>
			</div>
			<div class="emptyWrap"
				v-if="active == 1 && navList1[active1] && navList1[active1].theme_goods_list.data.length == 0">
				<img src="../../../static/images/empty.png" alt="" />
				<div style="">暂无数据</div>
			</div>
		</div>
		<div style="margin-top: 20px;" v-if="active!=1">
			<div class="tong three" v-if="navPcList && navPcList.total != 0">
				<goodsItem :title="title" :isVip="relationId ? true : false" :data="navPcList?navPcList.data:[]">
				</goodsItem>
			</div>
			<div class="tong three" v-if="navPcList && navPcList.total != 0">
				<el-pagination background style="text-align: center; padding-bottom: 50px" layout="prev, pager, next"
					:total="navPcList?navPcList.total:0" @current-change="handleCurrentChangePc" :current-page="page"
					:page-size="size">
				</el-pagination>
			</div>
			<div class="emptyWrap" v-if="navPcList && navPcList.total == 0">
				<img src="../../../static/images/empty.png" alt="" />
				<div style="">暂无数据</div>
			</div>
		</div>
		<!-- 底部 -->
		<Foots></Foots>
	</div>
</template>

<script>
	import Head from "@/components/head.vue";
	import Foots from "@/components/foots.vue";
	import goodsItem from "../../components/goods-item";
	import goodsItem3 from "../../components/goods-item3";
	export default {
		components: {
			Head,
			Foots,
			goodsItem,
			goodsItem3,
		},
		data() {
			return {
				page: 1,
				size: 10,
				dengji: "",
				dengjides: "",
				sort: "createAt",
				sortType: 1,
				salesNum: 1,
				comment: 1,
				sortImage1: true,
				sortImage2: true,
				sortImage3: true,
				sortImage4: true,
				searchList: [],
				navList: [{
						title: "全部分类",
						type: "",
					},
					{
						title: "首页",
						type: "",
					},
				],
				navList1: [],
				active: 1,
				active1: 0,
				active2: 0,
				active3: 0,
				number1: "",
				number2: "",
				number3: "",
				bannerList: [],
				leftList: [],
				secondsList: [],

				dataList: {
					content: [],
				},
				classList1: [{
						title: "综合",
						type: "createAt",
					},
					{
						title: "销量",
						type: "sales",
					},
					{
						title: "超低价",
						type: "price",
					},
				],

				relationId: this.$cookie.get("relationId"), //邀请码
				image_url: "", //头像
				nickName: "", //用户名
				invitationCode: "",
				phone: "", //电话
				isLogin: false,
				// userId : this.$cookie.get('userId'),
				dingdanCountList: {
					count1: 0,
					count2: 0,
					count3: 0,
					count4: 0,
					count5: 0,
				}, //订单数量
				type: "createAt",
				title: "热卖榜单",

				navlist: [],
				userName:'',
				jingXuan: [],
				reMai: [],
				gonggaoList: [],
				meiRi: [],
				pinTuan: [],
				classId: 1,
				arr1: [],
				navPcList: [], //pc首页导航
			};
		},
		mounted() {
			this.getLeftList();
			//底部推荐商品
			this.getTuiJianGoods();
			if (this.token) {
				// this.userSelect();
				this.getUserInfo();
			}
		},
		computed: {
			token() {
				return this.$cookie.get("token");
			},
			userName() {
				return this.$cookie.get("userName");
			},
			image_url(){
				return this.$cookie.get("avatar");
			}
		},
		methods: {
			//获取用户信息
			getUserInfo() {
				let that = this
				this.$http({
					url: this.$http.adornUrl3('api/index/index/my_index'),
					method: 'post',
					params: this.$http.adornParams({})
				}).then(({
					data
				}) => {
					if (data.code == 1) {
						that.userName = data.data.user_info.nickname
						that.$cookie.set('userName', data.data.user_info.nickname)
						that.$cookie.set('phone', data.data.user_info.mobile)
						that.$cookie.set('gender', data.data.user_info.gender)
						that.$cookie.set('avatar', data.data.user_info.avatar)
					}
				})
			},
			//banner下面的分类
			switchovers(item) {
				this.$router.push({
					path:'/productList?gotoType=4&nav_id='+item.id
				})
				// if (item) {
				// 	this.$router.push({
				// 		path: "/productList2?id=" + item.id + "&title=" + item.title,
				// 	});
				// } else {
				// 	this.$router.push({
				// 		path: "/productList2?id=141&title=虚拟商品001"
				// 	});
				// }

			},
			// 头部获取分类信息
			getFootShop(id) {
				this.$http({
					url: this.$http.adornUrl3("api/index/pcapi/index_nav"),
					method: "post",
					params: this.$http.adornParams({
						num: this.size,
						page: this.page,
						nav_id: id
					}),
				}).then(({
					data
				}) => {
					if (data.code == 1) {
						this.navPcList = data.data
					}
				});
			},
			//查看更多
			gotoMoreGoods() {
				this.$router.push({
					path: "/productList?gotoType=3",
				});
			},
			//底部推荐商品
			getTuiJianGoods() {
				this.$http({
					url: this.$http.adornUrl3("api/index/pcapi/pc_index_two"),
					method: "post",
					data: this.$http.adornParams({
						// num: this.size,
						num: 20,
						page: this.page
					}),
				}).then(({
					data
				}) => {
					if (data.code === 1) {
						this.navList1 = data.data
					}
				});
			},
			//跳转订单页面
			goOrder() {
				if(this.token){
					this.$router.push({
						path: "/order",
					});
				}else{
					this.$router.push({
						path: "/login",
					});
				}

			},
			//轮播图跳转
			bannerSkip(e) {
				window.location.href = e.banner_url;
			},
			onNavigation(index, item) {
				this.active = index == 0 ? 1 : index;
				this.active3 = 0; //重置排序
				this.page = 1;
				this.title = item.title;
				this.page = 1;
				this.getFootShop(item.id)

			},
			onNavigation1(index, item) {
				this.active1 = index;
				this.page = 1;
				this.getTuiJianGoods()
				// this.type = item.url.slice(
				// 	item.url.indexOf("cid=") + 4,
				// 	item.url.indexOf("&")
				// );
				// this.sort = "createAt";
				// this.classId = item.id;

				// if (item.title == "热卖榜单") {
				// 	this.title = "热卖榜单";

				// 	this.dataSelect();
				// } else {
				// 	this.title = "";
				// 	this.dataSelect();
				// }
			},
			onClick(id) {
				this.$router.push({
					path: "/productList?type=" + id + '&gotoType=2',
				});
			},
			handleCurrentChange(val) {
				this.page = val;
				this.getTuiJianGoods();
			},
			handleCurrentChangePc(val) {
				this.page = val;
				this.getFootShop();
			},
			// 获取用户信息
			userSelect() {
				this.$http({
					url: this.$http.adornUrl3("api/index/index/my_index"),
					method: "get",
					params: this.$http.adornParams({}),
				}).then(({
					data
				}) => {
					if (data.code == 1) {
						this.image_url = data.data.user_info.avatar
						this.$cookie.set("userName", data.data.user_info.nickname)
					}
				});
			},
			//分类/banner/推荐商品
			getLeftList() {
				this.$http({
					url: this.$http.adornUrl3("api/index/pcapi/pc_index_one"),
					method: "post",
					params: this.$http.adornParams({}),
				}).then(({
					data
				}) => {
					if (data.code === 1) {
						data.data.nav_list = JSON.parse(JSON.stringify(data.data.nav_list).replace(/"name"/g,
							'"title"'))
						this.leftList = data.data;
						this.navList = [...this.navList, ...data.data.nav_list]
						this.searchList = data.data.search_keyword.split(',')
						this.$cookie.set('searchList', this.searchList)
						this.secondsList = data.data.nav_list
						console.log(this.secondsList)
					}
				});
			},
			switchover(item) {
				// this.$router.push({
				// 	path: "/productList2?id=" + item.id + "&title=" + item.title,
				// });
				this.$router.push({
					path: '/productDetails?id=' + item.id
				})
			},

			/* 登录 */
			goLogin() {
				this.$router.push({
					path: "/login",
				});
			},
			// getSalesList(){
			// 	this.
			// },
		},
	};
</script>

<style scoped lang="less">
	.div1 {
		height: 100vh;
		overflow-x: hidden;
	}

	/* 导航 */
	.navigation {
		/* background: #FF2D55; */
		height: 40px;
		line-height: 40px;
		color: #333;
	}

	.navList {
		width: 1200px;
		margin: 0 auto;
		display: flex;
		align-content: center;
		justify-content: space-between;

		:nth-child(1) {
			width: 20%;
		}
	}

	.navName {
		border-bottom: 4px solid rgba(225, 37, 27, 0);
		/* display: inline-block; */
		// width: 16%;
		width: 65px;
		text-align: center;
		cursor: pointer;
		.line {
			width: 65px;
			height: 4px;
			background-color: #e1251b;
			margin: 0 auto;
		}
	}

	.active {
		background: #E1251B;
		color: #fff;
	}

	/* 第一部分 */
	.tong {
		width: 1200px;
		margin: 0 auto;
		// margin-top: 15px;
	}

	.ones {
		height: 450px;
	}

	.ist {
		display: inline-block;
		height: 440px;
		box-sizing: border-box;
	}

	.is_left {
		width: 20%;
		overflow-y: auto;
		/* margin-right: 1.5%; */
		line-height: 40px;
		padding: 20px;
		color: #333333;
		font-size: 14px;
		background: #fff;
		border-radius: 4px;
		float: left;
	}

	.nameCl:hover {
		color: #ff2d55;
		cursor: pointer;
	}

	.is_conts {
		width: 60%;
		/* margin-right: 1.5%; */
		height: 400px;
	}

	.bannerName {
		width: 100%;
		height: 100%;
	}

	.is_right {
		width: 20%;
		color: #333333;
		font-size: 14px;
		background: #fff;
		border-radius: 4px;
		box-sizing: border-box;
		height: 440px;
		float: right;
	}

	.rightTop {
		padding: 20px;
	}

	.imgTop {
		width: 50px;
		height: 50px;
		border-radius: 50%;
		float: left;
	}

	.topR {
		margin-left: 60px;
		line-height: 50px;
		// line-height: 25px;
	}

	.topL {
		margin-left: 60px;
		line-height: 50px;
		height: 50px;
	}

	.topL>div:hover {
		cursor: pointer;
	}

	.Rname {
		font-size: 20px;
	}

	.Ryaoqingma {
		font-size: 14px;
	}

	.rightVip {
		margin: 0 20px 15px;
		padding: 0;
		height: 40px;
		border-radius: 5px;
		background: #ff2d55;
		color: #fff;
	}

	.rightVip div {
		display: inline-block;
	}

	.rightNoVip {
		margin: 0 20px 15px;
		height: 40px;
		border-radius: 5px;
		background: #ff2d55;
		color: #fff;
		display: flex;
		justify-content: space-between;
		align-items: center;
		line-height: 40px;
		padding: 0 20px;
		font-size: 16px;
	}

	.rightBtn {
		width: 80px;
		height: 27px;
		text-align: center;
		font-size: 12px;
		color: #333;
		border-radius: 16px;
		z-index: 1;
		background: #fde3de;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.vipName {
		line-height: 40px;
		padding-left: 15px;
		font-size: 18px;
		font-weight: 600;
	}

	.vipKthy {
		background: #fff;
		font-size: 12px;
		color: #ff2d55;
		height: 20px;
		line-height: 20px;
		margin-left: 36%;
		padding: 0 6px;
		border-radius: 20px;
	}

	.vipKthy:hover {
		cursor: pointer;
	}

	.Rclass {
		padding: 0 20px 0;
		// border-bottom: 1px solid #F2F2F2;
		box-sizing: border-box;
		// margin-top: 30px;
	}

	.classList {
		display: inline-block;
		width: 23%;
		text-align: center;
		cursor: pointer;
	}

	.RlistNum {
		font-size: 24px;
		font-weight: 600;
	}

	.RlistName {
		font-size: 14px;
	}

	.Rbottom {
		padding: 0 15px 20px 15px;
		// padding: 15px 20px;
	}

	.bottomTitle {
		font-size: 20px;
		font-weight: 600;
		margin-bottom: 15px;
	}

	.bottomS {
		width: 100%;
		height: 30px;
		border-radius: 15px;
		background: #f2f2f2;
		text-align: center;
		line-height: 30px;
		font-size: 12px;
		margin: 20px 0px 0;
	}

	.bottomList {
		padding: 15px 0;
	}

	.listI {
		display: inline-block;
		width: 32%;
		text-align: center;
	}

	.bottomImg {
		width: 34px;
	}

	/* 第二部分 */
	.seconds {
		// background: url(../../assets/index/bg.png) no-repeat;
		background-size: 100% 100%;
		box-sizing: border-box;
		height: 640px;
		border-radius: 5px;
		display: flex;
	}

	.secondsleft {
		width: 20%;
		color: #c3004e;
		font-size: 18px;
		// padding: 20px;
		box-sizing: border-box;
		background: linear-gradient(39deg, #ffc1d8 1%, #ffb7cf 100%);
	}

	.backg1 {
		height: 320px;
		box-sizing: border-box;
		padding-top: 76px;
		text-align: center;
	}

	.backg2 {
		height: 320px;
		border-top-left-radius: 200px;
		background: linear-gradient(234deg, #ffa2c1 0%, #fdb2ce 100%);
	}

	.secondsleft_title {
		font-size: 30px;
		font-weight: 600;
		line-height: 40px;
	}

	.secondsleft_dixy {
		height: 177px;
	}

	.chakan {
		cursor: pointer;
	}

	.secondsRight {
		border: none;
		border-radius: 6px;
		background: #fff;
		display: flex;
		flex-wrap: wrap;
		box-sizing: border-box;
		width: 80%;
	}

	.secondsRight_list {
		width: 25%;
		box-sizing: border-box;
		padding: 20px;
		cursor: pointer;
		height: 320px;
	}

	.secondsRight_title {
		color: #333;
		text-align: left;
		font-size: 14px;
		height: 35px;
		width: 200px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.secondsRight_sm {
		font-size: 13px;
		color: #999;
		margin-bottom: 20px;
		text-align: center;
	}

	.secondsRight_img {
		width: 200px;
		height: 200px;
	}

	/* 第三部分 */
	.navList2 {
		width: 100%;
		height: 70px;
		font-size: 18px;
		color: #333;
		background: #fff;
		border-radius: 2px;
		display: flex;
		align-content: center;
		justify-content: center;
		margin-bottom: 20px;
	}

	.navName1 {
		flex: 1;
		text-align: center;
		cursor: pointer;
		border-radius: 4px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.active1 {
		width: 100px;
		height: 40px;
		background: #e1251b;
		border-radius: 20px;
		line-height: 40px;
		color: #fefefe;
	}

	/* 筛选表格 */
	.table_main table {
		width: 100%;
	}

	.table_main {
		margin-top: 40px;
	}

	table tr {
		/* border-bottom: 1px solid #e8e8e8; */
		background: #fff;
		display: flex;
	}

	table tr th {
		// padding: 16px 24px;
		/* border-right: 1px solid #e8e8e8; */
		/* border-bottom: 1px solid #e8e8e8; */
	}

	table tr td {
		padding: 16px 24px;
		/* border-right: 1px solid #e8e8e8; */
		border-bottom: 1px solid #e8e8e8;
	}

	table th {
		color: rgba(0, 0, 0, 0.85);
		font-weight: 400;
		font-size: 14px;
		line-height: 1.5;
	}

	.border-rt {
		border-right: none !important;
	}

	.border-bt {
		border-bottom: none !important;
	}

	.left-th {
		color: #fff;
		width: 112px;
		line-height: 50px;
		background: #e1251b;
	}

	.right-th {
		text-align: left;
		padding-left: 30px;
	}

	.className {
		background-color: #fff;
		font-size: 14px;
		color: #333;
		margin: 10px 5px;
		padding: 0 20px;
		text-align: center;
		cursor: pointer;
		display: flex;
		align-items: center;
	}

	.active2 {
		background: #ff2d55;
		color: #fff;
		border-radius: 4px;
	}

	.yxl {
		width: 70px;
		margin: 0 50px 0 10px;
		border: 1px solid #e6e6e6;
		height: 30px;
		line-height: 30px;
		border-radius: 4px;
	}

	.jiage1 {
		margin: 0 20px;
		width: 50px;
	}

	.emptyWrap {
		width: 100%;
		text-align: center;
		margin: 80px 0;
	}

	.emptyWrap>div {
		font-size: 24px;
		font-weight: 700;
		color: #999999;
	}

	.buffer {
		font-size: 20px;
		font-weight: bold;
		color: #333;
		margin: 36px auto 21px;
		display: flex;
		justify-content: space-between;
	}

	.buffer1 {
		height: 80px;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 26px;
		color: #333233;
		font-weight: bold;
	}

	.buffer1 {
		height: 80px;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 26px;
		color: #333233;
		font-weight: bold;
	}

	.conts_top {
		width: 23%;
		margin-left: 12px;
		background-color: #fff;
		border-radius: 3px;
		height: 100%;
		display: inline-block;
		position: relative;
		cursor: pointer;
	}

	.conts_two {
		width: 50%;
		display: inline-block;

	}

	.two_text {
		color: #E1251B;
		font-size: 18px;
		padding: 5px;
	}

	.two_span {
		font-size: 14px;
		color: #999999;
		padding: 5px;
	}

	.conts_three {
		width: 50%;
		display: inline-block;
		position: absolute;
		top: 13px;
		height: 100%;

	}
	.three_img {
		width: 60px;
		height: 60px;
		margin-left: 10px;
	}
</style>



// WEBPACK FOOTER //
// src/views/homePage/index.vue